import { ArrowRight } from "lucide-react";
import { motion } from "motion/react";
import { useRouter } from "next/navigation";

export const FoodCreatorStudioIntro = () => {
  const router = useRouter();

  return (
    <section
      id="kitchens"
      className="relative overflow-hidden bg-[#082419] py-16 text-white md:py-18"
      data-section-theme="light"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,95,71,0.34),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(10,92,54,0.24),transparent_34%)]" />
      <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mx-auto max-w-7xl"
        >
          <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
            <div>
              <h2 className="max-w-2xl font-asgard text-4xl leading-[0.96] tracking-[-0.04em] text-white md:text-5xl">
                Need space to cook, or room to share?
              </h2>
              <p className="mt-5 max-w-2xl font-satoshi text-lg leading-8 text-white/74">
                Creators can find a kitchen that fits how they work. Kitchen owners can fill quiet hours with vetted local talent.
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row lg:justify-end">
              <button
                type="button"
                onClick={() => router.push("/become-a-food-creator/apply?type=food-creator")}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#FF5F47] px-6 py-3.5 font-satoshi text-sm font-bold text-white transition hover:bg-[#ff715c]"
              >
                Find a kitchen
                <ArrowRight className="h-4 w-4" />
              </button>
              <button
                type="button"
                onClick={() => router.push("/become-a-food-creator/apply?type=studio-owner")}
                className="inline-flex items-center justify-center rounded-full border border-white/15 px-6 py-3.5 font-satoshi text-sm font-semibold text-white transition hover:bg-white/8"
              >
                List a kitchen
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FoodCreatorStudioIntro;
